export const ContentWrapper = ({topPadding = 110, children}) => (
  <div style={{margin: `0 auto 36px`, maxWidth: '1320px', paddingTop: `${topPadding}px`}}>
    {children}
  </div>
)